module.exports = __webpack_public_path__ + "img/orders.0c3a0d16.svg";